import React, { useState, useEffect } from 'react';
import { useParams, useNavigate, Link } from 'react-router-dom';
import databaseService from '../utils/database';
import './EventoDetalle.css';

export default function EventoDetalle() {
  const { id } = useParams();
  const navigate = useNavigate();
  const [evento, setEvento] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const cargarEvento = async () => {
      try {
        setLoading(true);
        let eventFound = false;
        
        try {
          const response = await databaseService.getEventById(id);
          if (response && response.success && response.event) {
            const eventData = {
              ...response.event,
              fechaISO: response.event.fechaISO || response.event.fecha || null
            };
            setEvento(eventData);
            eventFound = true;
          }
        } catch (endpointError) {
          console.warn('Error en endpoint individual:', endpointError);
        }
        
        if (!eventFound) {
          const allEvents = await databaseService.getEvents();
          const events = Array.isArray(allEvents?.events) ? allEvents.events : (Array.isArray(allEvents) ? allEvents : []);
          const searchId = parseInt(id);
          const foundEvent = events.find(e => {
            const eventId = typeof e.id === 'string' ? parseInt(e.id) : e.id;
            return eventId === searchId || eventId === parseInt(id) || String(eventId) === String(id);
          });
          
          if (foundEvent) {
            const eventData = {
              ...foundEvent,
              fechaISO: foundEvent.fechaISO || foundEvent.fecha || null
            };
            setEvento(eventData);
            eventFound = true;
          } else {
            setError(`Evento no encontrado. ID: ${id}`);
          }
        }
      } catch (err) {
        console.error('Error cargando evento:', err);
        try {
          const allEvents = await databaseService.getEvents();
          const events = Array.isArray(allEvents?.events) ? allEvents.events : (Array.isArray(allEvents) ? allEvents : []);
          const foundEvent = events.find(e => {
            const eventId = e.id;
            const searchId = parseInt(id);
            return eventId === searchId || eventId === id || String(eventId) === String(id);
          });
          if (foundEvent) {
            const eventData = {
              ...foundEvent,
              fechaISO: foundEvent.fechaISO || foundEvent.fecha || null
            };
            setEvento(eventData);
          } else {
            setError(`Evento no encontrado. ID buscado: ${id}`);
          }
        } catch (fallbackErr) {
          setError(`Error al cargar el evento: ${err.message}`);
        }
      } finally {
        setLoading(false);
      }
    };

    if (id) {
      cargarEvento();
    }
  }, [id]);

  // Datos demo
  const demoData = {
    organizador: {
      nombre: 'RecomiendaT',
      logo: '/images/RecomiendaT-logo.png',
      descripcion: '🤫 Las experiencias de networking para CEOs, inversores, nómadas digitales y emprendedores de México. Nueva ubicación y tema cada vez!',
      website: 'https://recomiendate.tiendamax.com'
    },
    anfitriones: [
      { nombre: 'Yana Immis', avatar: 'Y' },
      { nombre: 'Paola Zúñiga', avatar: 'P' },
      { nombre: 'Ana', avatar: 'A' },
      { nombre: 'Gerardo Torres', avatar: 'G' },
      { nombre: 'Diana Mendoza', avatar: 'D' },
      { nombre: 'GERARDO GRANADOS', avatar: 'GG' },
      { nombre: 'Genaro Maza', avatar: 'GM' }
    ],
    asistentes: {
      total: 127,
      nombres: ['Gerardo Torres', 'Diana Mendoza']
    },
    agenda: [
      { hora: '11:00 – 12:00', titulo: 'Coffee & First Hellos', descripcion: 'Empezamos en un lugar especial. Llega temprano, toma tu bebida y conoce al equipo.', transicion: '10 min walk' },
      { hora: '12:10 – 13:00', titulo: 'First Stop', descripcion: 'Descubre una exhibición de diseño local. Toca, admira y quizás encuentres algo especial para ti.', transicion: '20 min walk' },
      { hora: '13:20 – 14:00', titulo: 'Second Stop', descripcion: 'Explora una galería moderna llena de obras contemporáneas y sorpresas.', transicion: '10 min walk' },
      { hora: '14:10 – Open End', titulo: 'Last Stop & Optional Afterparty', descripcion: 'Quédate todo el tiempo que quieras en el lugar final. Conecta con otros participantes y disfruta de la experiencia—todo es pay-as-you-go.' }
    ],
    precios: {
      general: evento?.precio || 599,
      earlyBird: 499,
      earlyBirdFecha: '19 de Noviembre 2025',
      membresia: 'GRATIS para miembros GOLD'
    },
    beneficios: [
      { emoji: '☕', texto: 'Empieza tranquilo – con café y gente que entiende' },
      { emoji: '🎨', texto: 'Experimenta arte, diseño y joyas ocultas' },
      { emoji: '💎', texto: 'Ve joyería local y galerías curadas para los curiosos' },
      { emoji: '🚶‍♀️', texto: 'Camina por calles con historia y arte' },
      { emoji: '💬', texto: 'Conoce personas curiosas – fundadores, locales, viajeros, creativos' },
      { emoji: '✨', texto: 'Déjate sorprender – nosotros lo planificamos, tú solo disfruta' }
    ]
  };

  if (loading) {
    return (
      <div className="evento-detalle-loading">
        <div className="spinner"></div>
        <p>Cargando evento...</p>
      </div>
    );
  }

  if (error || !evento) {
    return (
      <div className="evento-detalle-error">
        <h2>Evento no encontrado</h2>
        <p>{error || 'El evento que buscas no existe'}</p>
        <button onClick={() => navigate('/')}>Volver al inicio</button>
      </div>
    );
  }

  // Formatear fecha y hora
  const fechaEvento = new Date(evento.fechaISO || evento.fecha);
  const fechaValida = !isNaN(fechaEvento.getTime());
  const diaEvento = fechaValida ? fechaEvento.getDate() : null;
  const mesEvento = fechaValida ? fechaEvento.toLocaleDateString('es-MX', { month: 'short' }).toUpperCase() : null;
  const diaSemana = fechaValida ? fechaEvento.toLocaleDateString('es-MX', { weekday: 'long' }) : null;
  const fechaCompleta = fechaValida ? fechaEvento.toLocaleDateString('es-MX', { day: 'numeric', month: 'long', year: 'numeric' }) : 'Fecha por confirmar';
  const horaFormateada = fechaValida ? fechaEvento.toLocaleTimeString('es-MX', { hour: '2-digit', minute: '2-digit', hour12: true }) : 'Hora por confirmar';

  // Determinar estado del evento
  const ahora = new Date();
  const diffMs = fechaValida ? fechaEvento - ahora : 0;
  const diffHoras = fechaValida ? diffMs / (1000 * 60 * 60) : 0;
  const estadoEvento = !fechaValida ? 'proximo' : diffMs < 0 ? (diffHoras > -6 ? 'en_curso' : 'finalizado') : 'proximo';

  // Obtener emoji según tipo
  const getTipoEmoji = (tipo) => {
    const tipoUpper = (tipo || '').toUpperCase();
    if (tipoUpper.includes('NETWORKING')) return '🤝';
    if (tipoUpper.includes('BOOTCAMP')) return '💼';
    if (tipoUpper.includes('INTERNATIONAL')) return '🌐';
    return '🎪';
  };

  return (
    <div className="evento-detalle-page">
      <div className="evento-detalle-wrapper">
        {/* Panel Izquierdo - Card del Evento */}
        <aside className="evento-sidebar">
          <div className="evento-card">
            {/* Logo del organizador */}
            <div 
              className="evento-card-logo" 
              onClick={() => navigate('/')}
              title="Ir a página principal"
            >
              <img src={demoData.organizador.logo} alt={demoData.organizador.nombre} />
            </div>

            {/* Imagen del evento */}
            <div className="evento-card-image">
              {evento.imagen_url ? (
                <img src={evento.imagen_url} alt={evento.titulo} />
              ) : (
                <div className="evento-card-image-placeholder">
                  <span>🎉</span>
                </div>
              )}
              {/* Badge de tipo */}
              <div className="evento-card-badge">{evento.tipo || 'EVENTO'}</div>
            </div>

            {/* Presentado por */}
            <div className="evento-card-presented">
              <div className="presented-label">Presentado por</div>
              <div className="presented-info">
                <div className="presented-avatar">
                  <img src={demoData.organizador.logo} alt={demoData.organizador.nombre} />
                </div>
                <div className="presented-details">
                  <div className="presented-nombre">{demoData.organizador.nombre}</div>
                  <button className="presented-arrow">→</button>
                </div>
              </div>
              <button className="presented-subscribe">Suscribirse</button>
              <div className="presented-description">{demoData.organizador.descripcion}</div>
              <div className="presented-social">
                <a href="#" className="social-link">🌐</a>
                <a href="#" className="social-link">📱</a>
              </div>
            </div>

            {/* Organizado por */}
            <div className="evento-card-organized">
              <div className="organized-label">Organizado por</div>
              <div className="organized-nombre">RecomiendaT Networking Events</div>
              <div className="organized-host-list">
                {demoData.anfitriones.map((anfitrion, idx) => (
                  <div key={idx} className="organized-host-item">
                    <div className="host-avatar">{anfitrion.avatar}</div>
                    <div className="host-nombre">{anfitrion.nombre}</div>
                    <div className="host-icon">📷</div>
                  </div>
                ))}
              </div>
            </div>

            {/* Asistentes */}
            <div className="evento-card-attendees">
              <div className="attendees-count-number">{demoData.asistentes.total}</div>
              <div className="attendees-count-label">asistieron</div>
              <div className="attendees-avatars">
                {demoData.asistentes.nombres.map((nombre, idx) => (
                  <div key={idx} className="attendee-avatar-small">{nombre.charAt(0)}</div>
                ))}
              </div>
              <div className="attendees-names">
                {demoData.asistentes.nombres[0]}, {demoData.asistentes.nombres[1]} y {demoData.asistentes.total - 2} más
              </div>
            </div>

            {/* Contactar */}
            <button className="evento-card-contact">Contactar con el anfitrión</button>
          </div>
        </aside>

        {/* Panel Derecho - Contenido Principal */}
        <main className="evento-main-content">
          {/* Banner destacado */}
          <div className="evento-featured-banner">
            Destacado en Ciudad de México →
          </div>

          {/* Título del evento */}
          <h1 className="evento-main-title">
            {evento.titulo} {getTipoEmoji(evento.tipo)} RecomiendaT {getTipoEmoji(evento.tipo)}
          </h1>

          {/* Organizador */}
          <div className="evento-main-organizer">
            <div className="main-organizer-name">{demoData.organizador.nombre}</div>
          </div>

          {/* Fecha y hora */}
          {fechaValida && (
            <div className="evento-main-date-time">
              <div className="evento-date-badge">
                <div className="date-badge-month">{mesEvento}</div>
                <div className="date-badge-day">{diaEvento}</div>
              </div>
              <div className="evento-date-info">
                <div className="date-day-name">{diaSemana}, {fechaCompleta}</div>
                <div className="date-time">{horaFormateada.replace(':', ' : ')}</div>
              </div>
            </div>
          )}

          {/* Ubicación */}
          <div className="evento-main-location">
            <span className="location-icon">📍</span>
            <span className="location-name">{evento.lugar || 'Ubicación por confirmar'}</span>
            <span className="location-external">↗</span>
            <div className="location-city">Ciudad de México, Ciudad de México</div>
          </div>

          {/* Sección de compra */}
          <div className="evento-main-tickets">
            <div className="tickets-label">Comprar entradas</div>
            {estadoEvento === 'finalizado' ? (
              <div className="tickets-closed-box">
                <div className="closed-icon">−</div>
                <div className="closed-text">Inscripción cerrada</div>
              </div>
            ) : (
              <button className="tickets-button">Obtener Boletos</button>
            )}
            <div className="tickets-note">
              Este evento {estadoEvento === 'finalizado' ? 'no está aceptando inscripciones actualmente. Puedes contactar con el anfitrión o suscribirte para recibir actualizaciones.' : 'tiene inscripciones abiertas. ¡Asegura tu lugar!'}
            </div>
          </div>

          {/* Acerca del evento */}
          <div className="evento-main-about">
            <div className="about-header">
              <h2>Sobre el evento</h2>
              <button className="about-icon">⚙️</button>
            </div>

            {/* Hook */}
            <div className="evento-hook-content">
              <div className="hook-main-title">☕🎨 RECOMIENDATE PRESENTS: {(evento.titulo || 'EVENTO').toUpperCase()} – 3 DESEOS CONCEDIDOS</div>
              <div className="hook-separator"></div>
              <div className="hook-quote">"Todo lo que se necesita es fe y confianza... y un poco de magia." – <em>Aladdin</em></div>
              <div className="hook-question"><strong>¿Y si tu evento de networking comenzara con una galleta de la fortuna y 50 nuevas conexiones?</strong></div>
              <div className="hook-text">Porque a veces—esos días sin expectativas—resultan ser exactamente lo que necesitabas.</div>
            </div>

            {/* Descripción */}
            {evento.descripcion && (
              <div className="evento-description">
                <p>{evento.descripcion}</p>
                <p>
                  Esta vez, exploraremos las calles vibrantes de <strong>{evento.lugar || 'la ciudad'}</strong>. 
                  Un lugar lleno de historia, arte contemporáneo y espacios únicos. Cada parada es un pequeño mundo 
                  propio, lleno de energía, textura y magia esperando ser descubierta.
                </p>
              </div>
            )}

            {/* Timeline */}
            <div className="evento-timeline">
              <div className="timeline-title">✨ LA EXPERIENCIA</div>
              {demoData.agenda.map((actividad, idx) => (
                <div key={idx} className="timeline-item">
                  <div className="timeline-time">{actividad.hora}</div>
                  <div className="timeline-bar">|</div>
                  <div className="timeline-content">
                    <div className="timeline-activity-title">{actividad.titulo}</div>
                    <div className="timeline-activity-desc">{actividad.descripcion}</div>
                    {actividad.transicion && <div className="timeline-transition"><em>{actividad.transicion}</em></div>}
                  </div>
                </div>
              ))}
            </div>

            {/* Tickets Info */}
            <div className="evento-tickets-info">
              <div className="tickets-info-title">🎟️ TICKET INFO</div>
              <ul className="tickets-info-list">
                <li><strong>{demoData.precios.general} MXN General:</strong> Acceso completo al evento</li>
                <li><strong>{demoData.precios.earlyBird} MXN Early Bird (Solo Miembros):</strong> <em>disponible hasta {demoData.precios.earlyBirdFecha}</em></li>
                <li><strong>{demoData.precios.membresia}</strong> – <Link to="/membresias">descubre aquí</Link></li>
              </ul>
              <div className="tickets-info-note">📩 El punto de inicio exacto se revelará vía invitación de calendario, 24 horas antes.</div>
            </div>

            {/* Por qué unirse */}
            <div className="evento-why-join">
              <div className="why-join-title">WHY JOIN?</div>
              <ul className="why-join-list">
                {demoData.beneficios.map((beneficio, idx) => (
                  <li key={idx}>
                    <span className="why-emoji">{beneficio.emoji}</span>
                    <span className="why-text">{beneficio.texto}</span>
                  </li>
                ))}
              </ul>
            </div>

            {/* Nota */}
            <div className="evento-note">
              <div className="note-text">🧾 <strong>Nota:</strong> Todo es <strong>pay-as-you-go</strong>. Café, snacks y compras en galería corren por tu cuenta.</div>
              <div className="note-text">Esto no es un tour. Es una pequeña escapada. Un paseo sin presión. Algo diferente en una ciudad que siempre se mueve rápido.</div>
              <div className="note-signature">Nos vemos ahí.</div>
            </div>
          </div>

          {/* Ubicación detallada */}
          <div className="evento-main-location-detail">
            <h3>Ubicación</h3>
            <div className="location-detail-name">{evento.lugar || 'Ubicación por confirmar'}</div>
            <div className="location-detail-address">{evento.lugar || 'Ciudad de México'}, CDMX, México</div>
            <div className="location-detail-note">La ubicación precisa se compartirá 24 horas antes del evento a tu correo electrónico [si estás en la lista, por supuesto]</div>
          </div>
        </main>
      </div>
    </div>
  );
}